import React, { PureComponent } from 'react';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import styles from './styles.scss';

import messages from '../../i18n';

import ClockCanvas from '../../ClockCanvas';

const MESSAGE_TIME = 3200;

export default class Message extends PureComponent {
  constructor(props) {
    super(props);
    this.showNextMessage = this.showNextMessage.bind(this);

    this.timer =
      setTimeout(this.showNextMessage, MESSAGE_TIME, true);

    this.state = {
      showNextMessage: false,
    };
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  showNextMessage(state) {
    this.setState({ showNextMessage: state });
  }

  render() {
    return (
      <div className={styles.contentContainer}>
        <ClockCanvas
          setCanvas={this.props.setCanvas}
          shouldCapture={this.props.features.camera.value}
        />
        {this.state.showNextMessage ? (
          <div
            className={cn(styles.message, styles.secondMessage)}
            key='firstMessage'
          >
            <FormattedMessage {...messages.soWhatsNext} />
          </div>
        ) : (
          <div className={cn(styles.message, styles.firstMessage)} key='secondMessage'>
            <FormattedMessage {...messages.youClockedIn} /> {moment().format('h:mm a')}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/home/ClockIn/FirstClockIn/Message/index.jsx